<form [formGroup]="underwritingFormGroup">
  <div class="pad-top-20 row column twelve lg-push-two md-eight md-push-two">
    <h2
      dsContent
      [contentPath]="'policy.newVehicleUnderwritingQuestionsHeader'"
      class="bold-header"
    ></h2>
    <div class="add-vehicle-title">
      <div class="row vehicle">
        <div class="flex self-center pad-10">
          <div class="self-center pad-right-30" aria-hidden="true">
            <span class="icon-auto"></span>
          </div>
          <div class="self-center">
            <div class="risk-info">
              <div class="caption" dsContent [contentPath]="'policy.newVehicleCaption'"></div>
              <div class="heading">
                {{ vehicleRiskDescription$ | async }}
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <ds-radio-group
        data-cy="vehicleUnderwritingQuestionsCheckbox"
        class="radio-group-container"
        [control]="'option'"
        [selectedAnswer]=""
        [parentFormGroup]="underwritingFormGroup"
        [options]="questions"
      >
      </ds-radio-group>
    </div>
  </div>

  <div class="row column twelve lg-push-two md-eight md-push-two">
    <call-to-action
      [displayBackButton]="true"
      [tertiaryButtonName]="'Cancel'"
      [disabled]="!validators()"
      primaryButtonName="Continue"
      (primaryEvent)="underwritingFormSubmit()"
      (tertiaryEvent)="cancelEvent.emit(true)"
      (backEvent)="goBackOneStep()"
    ></call-to-action>
  </div>
</form>
